import { render, staticRenderFns } from "./template-store.vue?vue&type=template&id=e9972d72&scoped=true"
import script from "./template-store.vue?vue&type=script&lang=ts"
export * from "./template-store.vue?vue&type=script&lang=ts"
import style0 from "./template-store.vue?vue&type=style&index=0&id=e9972d72&prod&lang=scss&scoped=true"
import style1 from "./template-store.vue?vue&type=style&index=1&id=e9972d72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9972d72",
  null
  
)

export default component.exports